import React, { useEffect, useState } from 'react';
import { getUploadedImagePath, useAppDispatch, useAppState } from '@nutastic/nutastic-react-app';
import { useParams } from 'react-router-dom';
import { WebsiteActions } from '../../state/actions.mjs';
import { CONSTANTS } from '../../utils/constants';
import classnames from 'classnames';
import { useNavigation } from '../../hooks/useNavigation';
import ContentNotFoundPage from './ContentNotFoundPage';

const componentClass = 'listPage';

const ListPage = () => {
    const [ listConfiguration, setListConfiguration ] = useState(null);
    const appDispatch = useAppDispatch();
    const { isProcessing, pages: { dynamicPages = [] } } = useAppState();
    const { loadPage } = useNavigation();
    const { id: listId } = useParams();
    const { title: pageTitle, description: pageDescription, sections } = listConfiguration || {};

    useEffect(() => {
        appDispatch({ type: WebsiteActions.REUP_STARTED });
        const pageToSet = dynamicPages.find(dPage => dPage?.slug === listId);
        setListConfiguration(pageToSet);
        setTimeout(() => {
            appDispatch({ type: WebsiteActions.REUP_DONE });
        }, 1000);
    }, [listId]);

    const renderContentList = (contentList, type) => {
        const classes = classnames(`${componentClass}__item`, {
            useWideImage: type === CONSTANTS.APPKEY_VIDEO || type === CONSTANTS.APPKEY_NEWS || type === CONSTANTS.APPKEY_SHOP,
            newsShopStyle: type === CONSTANTS.APPKEY_NEWS || type === CONSTANTS.APPKEY_SHOP
        });
        return (contentList || []).map(c => {
            const {image, slug, title, field_1: shortDesc, excerpt: productShortDesc, field_7: price} = c;
            const urlToLoad = type === CONSTANTS.APPKEY_SHOP ? `/shop/${slug}` : `/content/${type}/${slug}`;
            const subtext = type === CONSTANTS.APPKEY_SHOP ? productShortDesc : shortDesc;
            const priceTag = type === CONSTANTS.APPKEY_SHOP ? <span className="priceTag">${ price }</span> : null;
            return <div className={classes} onClick={() => loadPage(urlToLoad)}>
                <img src={getUploadedImagePath(image)} alt={`${title} | QuistarGo.com`} />
                { type === CONSTANTS.APPKEY_NEWS || type === CONSTANTS.APPKEY_SHOP ?
                    <div><h4>{ title }</h4><p>{ subtext }</p>{priceTag}</div>
                    :
                    <div><p>{ title }</p></div>
                }
            </div>
        });
    };

    return (!isProcessing && listConfiguration) ? <article className={componentClass}>
        <div className={`${componentClass}__header`}>
            <h1>{ pageTitle }</h1>
        </div>
        { pageDescription && <div className={`${componentClass}__description`}>{ pageDescription }</div> }
        {
            (sections || []).filter(s => s.hasOwnProperty('enableField') && s.enableField !== 'false').map((section, i) => {
                const { title, description, sliderItems, type } = section;
                return <div className={`${componentClass}__content`}>
                    <div className={`${componentClass}__section`}>
                        <h2>{ title }</h2>
                        <p>{ description }</p>
                    </div>
                    <div className={`${componentClass}__list`}>
                        { renderContentList(sliderItems, type) }
                    </div>
                </div>;
            })
        }
    </article> : <ContentNotFoundPage isProcessing={isProcessing} /> ;
};

export default ListPage;
